// extracted by mini-css-extract-plugin
export default {"root":"N2wzl9nvBpkC7JYcLzeD"};